import 'react-app-polyfill/ie11';
import 'babel-polyfill';
import 'console_polyfill';
import './config/sentry';
import jQuery from 'jquery';
import Backbone from 'backbone';
import 'utils/HandleMobileView';
import userPreferences from 'models/user/ViewerUserPreferences';
import DateUtil from 'utils/date/DateUtil';
import MainRouter from 'routers/MainRouter';
import 'twitterbootstrap';
import configureStore from './config/store';
import configureAxios from './config/axios';
import DiTokenManager from './auth/DiTokenManager';
import HereTokenManager from './auth/HereTokenManager';
import socialProfile from 'models/user/ViewerSocialProfile';
import { isReadonlyMode, isProductSupportMode } from 'system/SystemUtil';

// Overrides for page level styling
import 'ui-connect/styles/pages.module.css';

// Utility classes should override all other css when they're used. Thus, we need to import them after all other components.
import 'ui-connect/styles/utility.module.css';

export default () => {
    // Set the system time so that we can have reasonably accurate timestamps
    DateUtil.setSystemTime(window.SYSTEM_TIME_GMT);

    jQuery.ajaxSetup({
        cache: false
    });

    configureAxios();
    const store = configureStore();

    if (socialProfile.get('garminGUID')) {
        if (!isReadonlyMode() && !isProductSupportMode()) {
            DiTokenManager.initialize(true, socialProfile.get('garminGUID'));
        }
    } else {
        // User is not logged in but can view public pages
        DiTokenManager.initialize(false, null);
    }

    HereTokenManager.initialize();

    // We've mistakenly referenced Window instead of window. Temporary hack to get Safari to load
    // until we can replace all references to Window with window.
    if (typeof Window == 'undefined') {
        Window = {};
    }

    Window.App = new MainRouter({
        userPreferences: userPreferences,
        userProfile: socialProfile,
        contextPath: '/modern/',
        urlBustValue: window.URL_BUST_VALUE,
        viewerIsAuthenticated: window.viewerIsAuthenticated,
        gAuthHost: window.GAUTH_HOST,
        sessionLength: window.SESSION_LENGTH,
        webToken: window.WEB_TOKEN
    });

    // Need to load async so that the global Window.App is already created.
    let routePromises = [];
    routePromises.push(import('./routes/routes'));
    routePromises.push(import('./backbone/routes/fitness'));

    Promise.all(routePromises).then(() => {
        console.log('Starting Backbone Router');
        Backbone.history.start({ pushState: true, root: '/modern/' });
    });

    window.ConnectReduxStore = store;
};
